import React from "react";

export default function DataFreshness({ items = [] }) {
  if (!items.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2" data-testid="data-freshness">
      <span className="label-caps">Data freshness</span>
      {items.map((f) => (
        <span key={f.source} className="inline-flex items-center gap-1.5 text-xs text-ink-2">
          <span className="w-1.5 h-1.5 rounded-full" style={{ background: f.state === "fresh" ? "#93C020" : "#E5A93D" }} />
          <span className="font-semibold text-ink">{f.source}</span> · {f.status}
        </span>
      ))}
    </div>
  );
}
